// *******************************************************************************
// Toggle header classes
// *******************************************************************************

attachEvent('.hamburger', 'click', (ev) => {
  ev.preventDefault();
  const isOpen = document.body.classList.contains('is-open-menu');
  toggleMenuClass(!isOpen);
});

// *******************************************************************************
// Add class to body after some scroll
// *******************************************************************************
function addScrollingClass() {
  const topOffset = document.documentElement.scrollTop || document.body.scrollTop;
  document.body.classList.toggle('is-scrolled', topOffset > 30);
}

addScrollingClass();

let ticking = false;
document.addEventListener('scroll', () => {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      addScrollingClass();
      ticking = false;
    });
    ticking = true;
  }
});

let lastScrollTop = 0;
window.addEventListener(
  'scroll',
  () => {
    const isScrolledTop = window.pageYOffset || document.documentElement.scrollTop;
    document.body.classList.toggle('is-scrolled-up', isScrolledTop < lastScrollTop);
    lastScrollTop = isScrolledTop <= 0 ? 0 : isScrolledTop;
  },
  false,
);

// *******************************************************************************
// One Pager Theme Header
// *******************************************************************************

const secondaryMenuLinks = document.querySelectorAll('.site-header--secondary .menu__link.level-1');

if (secondaryMenuLinks.length) {
  const navListBody = document.querySelector('.site-header--secondary .menu__list.level-1');

  const sectionElements = {};
  secondaryMenuLinks.forEach((link) => {
    const linkId = link.getAttribute('href');
    if (linkId && linkId !== '#') {
      sectionElements[linkId] = document.querySelector(linkId.startsWith('http') ? `[href="${linkId}"]` : linkId);
    }
  });

  const scrollToSection = (sectionElem) => {
    const { top } = sectionElem.getBoundingClientRect();

    window.scrollTo({
      top: top + window.pageYOffset - getHeaderHeight() - 50,
      behavior: 'smooth',
    });
  };

  const initScrollTriggers = () => {
    secondaryMenuLinks.forEach((link) => {
      const linkId = link.getAttribute('href');
      const sectionElem = sectionElements[linkId];

      if (sectionElem) {
        gsap.timeline({
          scrollTrigger: {
            trigger: sectionElem,
            start: 'top center',
            end: 'bottom center',
            scrub: true,
            onToggle: (self) => {
              if (!self.isActive) {
                return;
              }

              if (windowWidth() <= breakpointMd) {
                const scrollPos = link.offsetLeft - (navListBody?.offsetWidth ?? 0) / 2 + (link?.offsetWidth ?? 0) / 2;
                navListBody?.scroll({
                  left: scrollPos,
                  behavior: 'smooth',
                });
              }
            },
            toggleClass: { targets: link, className: 'is-active' },
          },
        });
      }
    });
  };

  secondaryMenuLinks.forEach((link) => {
    const linkId = link.getAttribute('href');

    if (!linkId || linkId === '#') return;

    if (linkId.startsWith('#')) {
      const sectionElem = document.querySelector(linkId);
      if (sectionElem) {
        sectionElements[linkId] = sectionElem;

        link.addEventListener('click', (ev) => {
          scrollToSection(sectionElem);
          document.body.classList.remove('is-open-menu');
          ev.preventDefault();
        });
      }
    }
  });

  window.addEventListener('load', () => {
    setTimeout(initScrollTriggers, 0);
  });
}

attachEvent('.site-header__language-button', 'click', (event) => {
  event.target.closest('.site-header__language-wrap').classList.toggle('is-active');
});
